import { InputNumber } from "antd";

function InputQuantityMove({ value, onChange }) {
  return <InputNumber value={value} style={{ width: "100%" }} onChange={(val) => onChange(val)} />;
}

export default InputQuantityMove;
